/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  organizationSwitchConfirmationErrorMembershipRequired: {
    id: 'organization-switch.confirmation.error.membership-required',
    defaultMessage: 'User is not a member of the target organization.',
  },
  organizationSwitchConfirmationErrorOrganizationNotFound: {
    id: 'organization-switch.confirmation.error.organization-not-found',
    defaultMessage: 'The target organization does not exist.',
  },
  organizationSwitchConfirmationError: {
    id: 'organization-switch.confirmation.error',
    defaultMessage: 'Failed to switch organization. Try again later.',
  },
})
